import React from "react";
import {
  WorkflowBreadcrumbs as Breadcrumbs,
  BreadcrumbItem,
} from "@amzn/squad-front-end-shared-react-components";
import "./breadcrumbs.module.css";

export interface BreadcrumbsProps {
  /**
   * List of items to appear as the first n elements
   * of the breadcrumb (with optional links).
   */
  breadcrumbItems: BreadcrumbItem[];
  /**
   * Title of the workflow.  Will appear as the last element in the breadcrumb.
   */
  workflowTitle: string;
}

const WorkflowBreadcrumbs: React.FC<BreadcrumbsProps> = ({
  breadcrumbItems,
  workflowTitle,
}): JSX.Element => {
  return (
    <div>
      <Breadcrumbs
        breadcrumbItems={breadcrumbItems}
        workflowTitle={workflowTitle}
      />
    </div>
  );
};

export default WorkflowBreadcrumbs;
